
document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined') {
    console.warn('GSAP not loaded. Menu animations disabled.');
    return;
  }

  // --- Configuration ---
  const userConfig = window.menuAnimationConfig || {};
  
  if (userConfig.enable === false) return; // Exit if animations are disabled

  // Options: 'fade-slide' | 'scale-fade' | '3d-flip' | 'elastic'
  const ANIMATION_STYLE = userConfig.style || 'fade-slide';
  // Options: 'simple' | 'underline' | 'lift'
  const HOVER_STYLE = userConfig.hoverStyle || 'simple';
  
  const config = {
    duration: userConfig.duration || 0.4,
    ease: 'power2.out',
    stagger: 0.05
  };

  // --- 1. Top-level Menu Item Hover Effects ---
  const menuItems = document.querySelectorAll('.header__menu-item');

  menuItems.forEach(item => {
    const textSpan = item.querySelector('span');
    if (!textSpan) return;

    // Setup for underline style
    if (HOVER_STYLE === 'underline') {
      let bar = item.querySelector('.menu-item-underline-bar');
      if (!bar) {
        bar = document.createElement('span');
        bar.classList.add('menu-item-underline-bar');
        textSpan.style.position = 'relative';
        textSpan.appendChild(bar);
      }
    }
    
    item.addEventListener('mouseenter', () => {
      if (HOVER_STYLE === 'simple') {
        gsap.to(textSpan, {
          scale: 1.05,
          opacity: 0.8,
          duration: 0.3,
          ease: 'power1.out'
        });
      } else if (HOVER_STYLE === 'underline') {
         const bar = item.querySelector('.menu-item-underline-bar');
         if (bar) {
           gsap.to(bar, { width: '100%', duration: 0.3, ease: 'power2.out' });
         }
      } else if (HOVER_STYLE === 'lift') {
        gsap.to(textSpan, {
          y: -3,
          textShadow: "0px 5px 10px rgba(0,0,0,0.2)",
          duration: 0.3,
          ease: 'power1.out'
        });
      }
    });

    item.addEventListener('mouseleave', () => {
      if (HOVER_STYLE === 'simple') {
        gsap.to(textSpan, {
          scale: 1,
          opacity: 1,
          duration: 0.3,
          ease: 'power1.out'
        });
      } else if (HOVER_STYLE === 'underline') {
         const bar = item.querySelector('.menu-item-underline-bar');
         if (bar) {
           gsap.to(bar, { width: '0%', duration: 0.3, ease: 'power2.out' });
         }
      } else if (HOVER_STYLE === 'lift') {
        gsap.to(textSpan, {
          y: 0,
          textShadow: "none",
          duration: 0.3,
          ease: 'power1.out'
        });
      }
    });
  });

  // --- 2. Dropdown Menu Animations ---
  const detailsElements = document.querySelectorAll('header-menu details');

  detailsElements.forEach(details => {
    const summary = details.querySelector('summary');
    const submenu = details.querySelector('.header__submenu') || details.querySelector('.mega-menu__content');

    if (!summary || !submenu) return;

    let isAnimating = false;

    const openAnimation = () => {
      if (isAnimating) return;
      isAnimating = true;

      gsap.killTweensOf(submenu);
      const listItems = submenu.querySelectorAll('li');

      if (ANIMATION_STYLE === 'fade-slide') {
        gsap.fromTo(submenu, 
          { opacity: 0, y: -15, visibility: 'visible' },
          { opacity: 1, y: 0, duration: config.duration, ease: config.ease, onComplete: () => isAnimating = false }
        );
      } else if (ANIMATION_STYLE === 'scale-fade') {
         gsap.fromTo(submenu, 
          { opacity: 0, scaleY: 0.9, transformOrigin: 'top center', visibility: 'visible' },
          { opacity: 1, scaleY: 1, duration: config.duration, ease: config.ease, onComplete: () => isAnimating = false }
        );
      } else if (ANIMATION_STYLE === '3d-flip') {
        gsap.fromTo(submenu,
          { opacity: 0, rotationX: -90, transformOrigin: 'top center', visibility: 'visible' },
          { opacity: 1, rotationX: 0, duration: config.duration, ease: 'back.out(1.5)', onComplete: () => isAnimating = false }
        );
      } else if (ANIMATION_STYLE === 'elastic') {
        gsap.fromTo(submenu,
          { opacity: 0, y: -20, visibility: 'visible' },
          { opacity: 1, y: 0, duration: config.duration + 0.4, ease: 'elastic.out(1, 0.5)', onComplete: () => isAnimating = false }
        );
      }

      // Stagger list items
      if (listItems.length > 0) {
        gsap.fromTo(listItems,
          { opacity: 0, x: -10 },
          { opacity: 1, x: 0, duration: 0.3, stagger: 0.03, delay: 0.1 }
        );
      }
    };

    const closeAnimation = (e) => {
      if (!details.hasAttribute('open')) return;
      
      e.preventDefault(); // Stop immediate closing
      if (isAnimating) return;
      isAnimating = true;

      const onCompleteClose = () => {
        details.removeAttribute('open');
        isAnimating = false;
        // Reset transforms
        gsap.set(submenu, { clearProps: 'all' }); 
      };

      if (ANIMATION_STYLE === 'fade-slide') {
        gsap.to(submenu, { opacity: 0, y: -10, duration: 0.2, ease: 'power1.in', onComplete: onCompleteClose });
      } else if (ANIMATION_STYLE === 'scale-fade') {
        gsap.to(submenu, { opacity: 0, scaleY: 0.9, duration: 0.2, ease: 'power1.in', onComplete: onCompleteClose });
      } else if (ANIMATION_STYLE === '3d-flip') {
        gsap.to(submenu, { opacity: 0, rotationX: -90, duration: 0.25, ease: 'power1.in', onComplete: onCompleteClose });
      } else if (ANIMATION_STYLE === 'elastic') {
        gsap.to(submenu, { opacity: 0, y: -10, duration: 0.2, ease: 'power1.in', onComplete: onCompleteClose });
      }
    };

    // We rely on the native toggle for opening (it adds the open attribute),
    // then we animate.
    // But for closing, we must intercept the click to animate BEFORE the attribute is removed.
    
    summary.addEventListener('click', (e) => {
      if (details.hasAttribute('open')) {
        // If it's already open, this click intends to close it.
        closeAnimation(e);
      }
      // If it's closed, the default behavior adds 'open' attribute, 
      // then the 'toggle' listener below fires to animate the opening.
    });

    // Detect opening via toggle event (covers both click and keyboard interaction)
    details.addEventListener('toggle', () => {
      if (details.open) {
        // Wait a tick for the browser to render the opened state, then animate
        requestAnimationFrame(() => openAnimation());
      }
    });
    
    // Handle clicks outside to close
    document.addEventListener('click', (e) => {
      if (details.hasAttribute('open') && !details.contains(e.target)) {
        // This is a click outside.
        // We need to manually trigger our close animation logic
        // because the native behavior might just close it instantly if handled by other scripts,
        // or we need to handle it ourselves.
        // NOTE: The 'details-disclosure' script usually handles focusout/clickout.
        // If that script runs first, it might remove 'open' before we can animate.
        // We'll leave the outside click handling to the theme's default script for now
        // to avoid conflicts, but if it snaps closed, that's why.
      }
    });
  });

  // --- 3. Mobile Drawer Animations ---
  /*
  const mobileDrawerDetails = document.querySelector('#Details-menu-drawer-container');
  if (mobileDrawerDetails) {
    const mobileDrawer = mobileDrawerDetails.querySelector('.menu-drawer');
    const mobileSummary = mobileDrawerDetails.querySelector('summary');

    if (mobileDrawer && mobileSummary) {
      let isMobileAnimating = false;

      const openMobileDrawer = () => {
        if (isMobileAnimating) return;
        isMobileAnimating = true;

        gsap.fromTo(mobileDrawer, 
          { xPercent: -100, opacity: 0 },
          { xPercent: 0, opacity: 1, duration: 0.4, ease: 'power2.out', onComplete: () => isMobileAnimating = false }
        );
      };

      const closeMobileDrawer = (e) => {
        if (!mobileDrawerDetails.hasAttribute('open')) return;
        
        e.preventDefault();
        if (isMobileAnimating) return;
        isMobileAnimating = true;

        gsap.to(mobileDrawer, {
          xPercent: -100,
          opacity: 0,
          duration: 0.3,
          ease: 'power2.in',
          onComplete: () => {
            mobileDrawerDetails.removeAttribute('open');
            isMobileAnimating = false;
            // Reset position for next open
            gsap.set(mobileDrawer, { xPercent: 0, opacity: 1 });
          }
        });
      };

      mobileSummary.addEventListener('click', (e) => {
        if (mobileDrawerDetails.hasAttribute('open')) {
          closeMobileDrawer(e);
        }
      });

      mobileDrawerDetails.addEventListener('toggle', () => {
        if (mobileDrawerDetails.open) {
          requestAnimationFrame(() => openMobileDrawer());
        }
      });

      // Close button inside drawer
      const closeButtons = mobileDrawer.querySelectorAll('.menu-drawer__close-button');
      closeButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
             if (mobileDrawerDetails.hasAttribute('open')) {
                closeMobileDrawer(e);
             }
        });
      });
      
      mobileDrawerDetails.addEventListener('click', (e) => {
         if (e.target === mobileDrawerDetails && mobileDrawerDetails.hasAttribute('open')) {
            closeMobileDrawer(e);
         }
      });
    }
  }
  */
});
